module.exports = __webpack_public_path__ + "img/register_success.38fa714d.svg";